import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { BORDER_RADIUS, semanticColors } from '@/theme/tokens';

/**
 * Shown on a ballot whose election has been held: the ballot stays as the voter's
 * record, and its picks remain editable. Mirrors the mobile app's ElectionEndedNotice.
 */
export default function ElectionEndedNotice() {
  const { t } = useTranslation('ballot');
  return (
    <Box
      component="section"
      aria-labelledby="election-ended-notice-title"
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1,
        mx: 1,
        // The ballot column has no top padding and a 16px gap below this notice;
        // a matching top margin centers it between the tab and the election card.
        mt: 2,
        px: 1.5,
        py: 1.25,
        backgroundColor: semanticColors.warningBackground,
        border: `1px solid ${semanticColors.warningBannerBorder}`,
        borderRadius: BORDER_RADIUS,
      }}
    >
      <EventAvailableOutlinedIcon
        fontSize="small"
        aria-hidden="true"
        sx={{ color: semanticColors.warningText, mt: '1px' }}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
        <Typography
          id="election-ended-notice-title"
          component="h2"
          variant="body2"
          sx={{ fontWeight: 600, color: semanticColors.warningText }}
        >
          {t('elections.endedTitle')}
        </Typography>
        <Typography variant="caption" sx={{ color: semanticColors.warningText, lineHeight: 1.45 }}>
          {t('elections.endedBody')}
        </Typography>
      </Box>
    </Box>
  );
}
